import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { API } from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { Phone } from './core.module';

export const COMPANY_CONTRACTS_API_NAME: string = 'company_contracts';
export const COMPANY_CONTRACTS_API_ENDPOINT: string = environment.API_BASE_PATH + '/company-contract';

@Injectable({
  providedIn: 'root',
})
export class CompanyContractsService {
  createContract(company_id: string, sales_network_id?: string): Observable<any> {
    const api_name: string = COMPANY_CONTRACTS_API_NAME;
    const path: string = `/company/${company_id}`;
    const init = {
      response: true,
      body: { sales_network_id },
    };
    return from(API.post(api_name, path, init));
  }

  listCompanyContracts(company_id: string): Observable<any> {
    const api_name: string = COMPANY_CONTRACTS_API_NAME;
    const path: string = `/company/${company_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  acceptContract(company_id: string, contract_id: string): Observable<any> {
    const api_name: string = COMPANY_CONTRACTS_API_NAME;
    const path: string = `/${contract_id}/company/${company_id}/accept`;
    const init = {
      response: true,
    };
    return from(API.post(api_name, path, init));
  }

  denyContract(company_id: string, contract_id: string): Observable<any> {
    const api_name: string = COMPANY_CONTRACTS_API_NAME;
    const path: string = `/${contract_id}/company/${company_id}/deny`;
    const init = {
      response: true,
    };
    return from(API.post(api_name, path, init));
  }

  deleteContract(company_id: string, contract_id: string): Observable<any> {
    const api_name: string = COMPANY_CONTRACTS_API_NAME;
    const path: string = `/${contract_id}/company/${company_id}`;
    const init = {
      response: true,
    };
    return from(API.del(api_name, path, init));
  }

  download(contract_id: string, company_id: string, is_signed: boolean): Observable<any> {
    const api_name: string = COMPANY_CONTRACTS_API_NAME;
    const path: string = `/${contract_id}/company/${company_id}/download`;
    const init = {
      response: true,
      headers: {
        Accept: 'application/pdf',
      },
      responseType: 'blob',
      queryStringParameters: { is_signed },
    };
    return from(API.get(api_name, path, init));
  }
}

export enum CompanyContractStatus {
  pending = 'pending',
  signed = 'signed',
  accepted = 'accepted',
  denied = 'denied',
}

export interface CompanyContractSigner {
  firstname: string;
  lastname: string;
  birthday?: string;
  phone: Phone;
  email: string;
}

export interface CompanyContract {
  company_contract_id?: string;
  object?: string;
  company_id?: string;
  status?: CompanyContractStatus;
  signed_file_path?: string;
  file_path?: string;
  signer?: CompanyContractSigner;
  file_url?: string;
  signed_file_url?: string;
  signed_at?: number;
  accepted_at?: number;
  accepted_by?: string;
  denied_at?: number;
  created_at?: number;
  updated_at?: number;
}
